<template>
  <div class="card">
    <div class="card-body p-0">
      <textarea class="form-control form-control-sm border-0 py-2"
                rows="4"
                placeholder="Add comment here . . ">
      </textarea>
    </div>
    <div class="card-footer bg-white">
      <div class="row no-gutters justify-content-between align-items-center">
        <div class="col-12 col-md-auto align-content-center">
          <button class="plain-btn">
            <font-awesome-icon icon="plus"/>
          </button>
          <button class="plain-btn">
            <font-awesome-icon icon="pencil"/>
          </button>
          <button class="plain-btn">
            <font-awesome-icon icon="trash"/>
          </button>
        </div>
        <div class="col-12 col-md-auto">
          <base-primary-btn btn-size="sm">COMMENT</base-primary-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCommentCard",
  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** components **/
  components: {},

  /** methods **/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },
}
</script>

<style scoped lang="scss">
 .plain-btn {
   border: 0;
   padding: .15em .45em;
   color: #2c3e50;
   border-radius: 100%;
   margin: 0 .15em;
   outline-style: none;
   background-color: white;
 }
 .plain-btn:hover {
   background-color: rgba(0,0,0,.1);
 }
 .plain-btn:focus {
   background-color: rgba(0,0,0,.1);
 }

</style>